module.exports = __webpack_public_path__ + "img/product_category_preview_image-6.22c4550.webp";